module.exports = __webpack_public_path__ + "static/img/tourist.80982d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tourist.png
// module id = Zc5J
// module chunks = 1